import React, { useState, useRef, useEffect } from 'react';
import { IoClose } from "react-icons/io5";
import { showErrorToast, showSuccessToast } from '../../utils/toastUtils';
import { verifyMobileOtpValidation } from "../../Services/ApiTestService/apiTestService";
import Loader from '../../Loader';



const PinInput = ({ inputRefs, onPinChange, onSubmit }) => {
  const [pin, setPin] = useState(['', '', '', '', '', '']);

  const handleChange = (index, value) => {
    const newPin = [...pin];

    // Allow only digits
    if (!/^\d*$/.test(value)) return;

    newPin[index] = value;
    setPin(newPin);

    const fullPin = newPin.join('');
    if (onPinChange) onPinChange(fullPin);

    // Move to next box automatically
    if (value !== '' && index < 5) {
      inputRefs.current[index + 1].current.focus();
    }

    // Auto-submit once 6 digits entered
    if (fullPin.length === 6 && onSubmit) {
      onSubmit(fullPin);
    }
  };

  const handleBackspace = (index, event) => {
    if (event.key === 'Backspace' && pin[index] === '' && index > 0) {
      inputRefs.current[index - 1].current.focus();
    }
  };

  return (
    <div className="flex justify-center mb-4">
      {pin.map((value, index) => (
        <React.Fragment key={index}>
          <input
            ref={inputRefs.current[index]}
            type="password"
            maxLength={1}
            value={value}
            onChange={(e) => handleChange(index, e.target.value)}
            onKeyDown={(e) => handleBackspace(index, e)}
            className="border border-blue-500 md:w-10 md:h-10 w-9 h-10 
                       text-center mx-1 rounded shadow-lg shadow-blue-600"
            autoFocus={index === 0}
          />

          {/* Dash between 3rd and 4th digit */}
          {index === 2 && <span className="mt-2 text-sky-500 ml-1">&ndash;</span>}
        </React.Fragment>
      ))}
    </div>
  );
};




const MobileValidationOTPModel = ({
  isModalOpen,
  toggleModal,
  mobNumber,
  onSuccess,
  txnID,
  profileData,
}) => {

  // Create refs only ONCE
  const inputRefs = useRef([...Array(6)].map(() => React.createRef()));
  const [otp, setOtp] = useState("");
  const [error, setError] = useState("");
    const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (currentOtp = otp.trim()) => {
    setError("");

    if (currentOtp.length !== 6) {
      setError("Please enter a 6-digit OTP.");
      return;
    }

    const payload = {
      api_id: profileData?.user_id,
      api_key: profileData?.api_key,
      token_id: profileData?.token_id,
      txn_id: txnID,
      otp_value: currentOtp,
      method: "final",
    };
    setIsLoading(true);

    try {
      const result = await verifyMobileOtpValidation(payload);

      if (result?.status?.code === 200) {
        const verifiedData = result?.data || {};
        showSuccessToast(result?.message || "Verification successful");
        onSuccess?.(verifiedData);
        return;
      }

      if (result?.status?.code === 422 && result?.errors) {
        Object.values(result.errors).flat().forEach((msg) => showErrorToast(msg));
        setError("Validation error. Please check your details.");
        return;
      }

      const msg = result?.message || result?.status?.message || "OTP verification failed";
      showErrorToast(msg);
      setError(msg);
    } catch (err) {
      const errRes = err?.response?.data || {};
      const msg =
        errRes?.status?.message ||
        errRes?.message ||
        err?.message ||
        "OTP verification failed";

      showErrorToast(msg);
      setError(msg);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    isModalOpen && (
      <div
        className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50"
        style={{ zIndex: 999999 }}
      >

      {/* Loader Overlays Above Modal */}
        {isLoading && (
          <div className="absolute inset-0 flex items-center justify-center z-50">
            <Loader />
          </div>
        )}


        <div className="bg-white rounded-lg shadow-lg w-11/12 md:w-1/3">
          <div className="bg-[#12086c] text-white relative py-2 rounded-t-lg text-center">

            <p className="text-white text-xl mb-1">
              OTP sent to your mobile ending with{" "}
              <span className="font-semibold">
                {mobNumber ? `XXXXXX${mobNumber.slice(-4)}` : ""}
              </span>
            </p>

            <IoClose
              color="white"
              className="text-2xl absolute right-4 top-1/2 -translate-y-1/2 cursor-pointer"
              onClick={toggleModal}
            />
          </div>

          <div className="p-3">
            <PinInput
              inputRefs={inputRefs}
              onPinChange={setOtp}
              onSubmit={handleSubmit}
            />

            {error && <div className="text-red-500 mt-1 text-center">{error}</div>}
          </div>

          <div className="p-2 flex justify-center gap-3">
            <button
              type="button"
              className="text-white bg-red-600 font-semibold rounded-md px-3 py-1 hover:bg-gray-500"
              onClick={toggleModal}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    )
  );
};



export default MobileValidationOTPModel;
